var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.375 3.5625C4.02881 3.5625 2.9375 4.65381 2.9375 6V13.5C2.9375 14.8462 4.02881 15.9375 5.375 15.9375H14.375C15.7212 15.9375 16.8125 14.8462 16.8125 13.5V6C16.8125 4.65381 15.7212 3.5625 14.375 3.5625H5.375ZM1.8125 6C1.8125 4.03249 3.40749 2.4375 5.375 2.4375H14.375C16.3425 2.4375 17.9375 4.03249 17.9375 6V13.5C17.9375 15.4675 16.3425 17.0625 14.375 17.0625H5.375C3.40749 17.0625 1.8125 15.4675 1.8125 13.5V6Z",
    fill: "#585A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 0.9375C7.18566 0.9375 7.4375 1.18934 7.4375 1.5V4.5C7.4375 4.81066 7.18566 5.0625 6.875 5.0625C6.56434 5.0625 6.3125 4.81066 6.3125 4.5V1.5C6.3125 1.18934 6.56434 0.9375 6.875 0.9375ZM12.875 0.9375C13.1857 0.9375 13.4375 1.18934 13.4375 1.5V4.5C13.4375 4.81066 13.1857 5.0625 12.875 5.0625C12.5643 5.0625 12.3125 4.81066 12.3125 4.5V1.5C12.3125 1.18934 12.5643 0.9375 12.875 0.9375ZM1.8125 7.5C1.8125 7.18934 2.06434 6.9375 2.375 6.9375H17.375C17.6857 6.9375 17.9375 7.18934 17.9375 7.5C17.9375 7.81066 17.6857 8.0625 17.375 8.0625H2.375C2.06434 8.0625 1.8125 7.81066 1.8125 7.5Z",
    fill: "#585A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCalendar);
export default __webpack_public_path__ + "static/media/icons_calendar.e5ff172cd17a6031bbe6b7afdfc6e802.svg";
export { ForwardRef as ReactComponent };